module.exports = __webpack_public_path__ + "img/image 5.0a0720a9.png";